import NavLink from "./navlink";

const ContactButton = ({ className = "", children }) => {
        return (
                <NavLink target="contact" className={`btn-primary ${className}`}>
                        {children}
                </NavLink>
        )
}


export default ContactButton;
